import * as yup from 'yup'
import { REGEX_EMAIL, REGEX_PHONE_NUMBER, REGEX_SPECIAL_CHARACTER } from '~/constants'
import { AUTH_CRITERIA } from '~/validate/constant/auth'
import { validateMessage } from '~/resources/validate-message'
import { useUserData } from '~/composables/account/use-user-data'

export const formUpdateProfileSchema = yup.object().shape({
  username: yup.string(),
  fullname: yup.lazy((value: string) => {
    if (!value || value.trim() === '') {
      return yup.string().required('Vui lòng nhập tên hiển thị.')
    }
    return yup
      .string()
      .min(6, validateMessage.min)
      .max(32, validateMessage.max)
      .matches(
        new RegExp(REGEX_SPECIAL_CHARACTER),
        'Nhập tên hiển thị viết liền không dấu và không chứa các ký tự đặc biệt.'
      )
      .test('not-username', 'Tên hiển thị là duy nhất và không trùng với tên đăng nhập.', function (value) {
        const username: string = this.parent.username.toLowerCase() || ''
        return username !== value?.toLowerCase()
      })
  }),
  email: yup.lazy(value => {
    const { currentUser } = useUserData()

    if (value && value.trim() !== '' && !currentUser.value.email) {
      return yup
        .string()
        .matches(new RegExp(REGEX_EMAIL), 'Email không hợp lệ.')
        .email('Email không hợp lệ.')
        .max(50, 'Vui lòng không nhập quá 50 ký tự.')
    }
    return yup.string().nullable()
  }),
  phoneNumber: yup.lazy(value => {
    const { currentUser } = useUserData()

    if (value && value.trim() !== '' && !currentUser.value.phone) {
      return yup
        .string()
        .required('Xin hãy nhập số điện thoại của bạn.')
        .min(AUTH_CRITERIA.PHONE_MIN_LENGTH, validateMessage.min)
        .max(AUTH_CRITERIA.PHONE_MAX_LENGTH, validateMessage.max)
        .matches(new RegExp(REGEX_PHONE_NUMBER), 'Số điện thoại bắt đầu từ 0. Ví dụ: 0909123456.')
    }
    return yup.string().nullable()
  })
})

export const updateDisplaynameSchema = yup.object().shape({
  fullname: yup
    .string()
    .required('Vui lòng nhập tên hiển thị')
    .min(6, 'Vui lòng nhập từ 6 tới 32 ký tự')
    .matches(new RegExp(REGEX_SPECIAL_CHARACTER), 'Tên hiển thị không chứa ký tự đặc biệt')
    .test('not-current', 'Tên hiển thị đã tồn tại', value => {
      const { currentUser } = useUserData()
      if (new RegExp(`^${currentUser.value.username || ''}$`, 'i').test(value)) {
        return false
      }
      return !(new RegExp(`^${currentUser.value.fullname || ''}$`, 'i').test(value))
    })
})
